import { render, staticRenderFns } from "./organization-header.vue?vue&type=template&id=bd80dd22&scoped=true&"
import script from "./organization-header.vue?vue&type=script&lang=js&"
export * from "./organization-header.vue?vue&type=script&lang=js&"
import style0 from "./organization-header.vue?vue&type=style&index=0&id=bd80dd22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd80dd22",
  null
  
)

export default component.exports